import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Steper from "Component/Steper/Steper";
import Detailsbox from "./detailsbox";
import { useNavigate } from "react-router-dom";

// modals
import Selecttokenmod from "Component/Modals/Selecttokenmod";
import BCtowalletmod from "Component/Modals/BCtowalletmod";
import BCtowalletmodtwo from "Component/Modals/BCtowalletmodtwo";
import Enteremailmodal from "Component/Modals/Enteremailmodal";
import Verifyemailmodal from "Component/Modals/Verifyemailmodal";
import Personaldetailsmod from "Component/Modals/Personaldetailsmod";
import KYCmodal from "Component/Modals/KYCmodal";
import Processingmodal from "Component/Modals/Processingmodal";
import useToastr from "helpers/toastr";


const Buydetails = () => {
  const navigate = useNavigate();
  const [selecttoken, setselectoken] = useState(false);
  const [buycryptomodone, setbuycryptomodone] = useState(false);
  const [buycryptomodtwo, setbuycryptomodtwo] = useState(false);
  const [enteremailmod, setEnteremailmod] = useState(false);
  const [verifyemailmod, setVerifyemailmod] = useState(false);
  const [personladetailmod, setPersonladetailmod] = useState(false);
  const [kycmodal, setkycmodal] = useState(false);
  const [processingmodal, setProcessingmodal] = useState(false);

  const toastr = useToastr();


  const togglemodalone = () => {
    setbuycryptomodtwo(!buycryptomodtwo);
    setTimeout(() => {
      setbuycryptomodone(!buycryptomodone);
    }, 0);
  };

  const toggleentermod = () => {
    setEnteremailmod(!enteremailmod);
    setTimeout(() => {
      setbuycryptomodtwo(!buycryptomodtwo);
    }, 0);
  };

  const toggleverifymod = () => {
    setVerifyemailmod(!verifyemailmod);
    setTimeout(() => {
      setEnteremailmod(!enteremailmod);
    }, 0);
  };

  const togglepersonalmod = () => {
    setPersonladetailmod(!personladetailmod);
    setTimeout(() => {
      setVerifyemailmod(!verifyemailmod);
    }, 0);
  };


  const kyctoggle = () => {
    setkycmodal(!kycmodal);
    setTimeout(() => {
      setPersonladetailmod(!personladetailmod);
    }, 0);
  };


  const processtoggle = () => {
    setProcessingmodal(!processingmodal);
    setTimeout(() => {
      setkycmodal(!kycmodal);
    }, 0);
  };

  return (
    <Fade>
      <Selecttokenmod show={selecttoken} onHide={() => setselectoken(false)} />
      <BCtowalletmod
        show={buycryptomodone}
        onHide={() => setbuycryptomodone(false)}
        togglemodalone={togglemodalone}
        title="Buy Crypto To Your Wallet"
      />
      <BCtowalletmodtwo
        show={buycryptomodtwo}
        onHide={() => setbuycryptomodtwo(false)}
        toggleentermod={toggleentermod}
        title="Buy ETH To Your Wallet"
      />

      <Enteremailmodal
        show={enteremailmod}
        onHide={() => setEnteremailmod(false)}
        toggleverifymod={toggleverifymod}
        title="Please Enter Your Email"
      />

      <Verifyemailmodal
        show={verifyemailmod}
        onHide={() => setVerifyemailmod(false)}
        togglepersonalmod={togglepersonalmod}
        title="Verify your Email"
      />

      <Personaldetailsmod
        show={personladetailmod}
        onHide={() => setPersonladetailmod(false)}
        kyctoggle={kyctoggle}
        title="Personal Details"

      />

      <KYCmodal
        show={kycmodal}
        onHide={() => setkycmodal(false)}
        processtoggle={processtoggle}
        title="Kyc Document"

      />

       <Processingmodal
        show={processingmodal}
        onHide={() => setProcessingmodal(false)}
        title="Payment Processing"

      />


      <section className="home_banner_main buy_page position-relative">
        <div className="top_circle"></div>

        <Container fluid className="position-relative container_postition">
          <Row>
            <Col lg={3} md={6} sm={12} className="order-2 order-lg-1">
              <Detailsbox />
            </Col>
            <Col lg={5} md={6} sm={12} className="order-1 order-lg-2">
              <div className="buy_cryptoform position-relative text-start">
                <Form className="buy_crpto_form">
                  <div className="buy_form_head d-flex justify-content-between align-items-center">
                    <h2>Buy Crypto</h2>
                    {/* <p>
                      (1) <span>First Step</span>
                    </p> */}
                  </div>

                  <div className="Buy_btn_card mt-5">
                    <div className="form_liqudity">
                      <FormGroup className="input_here_wrap">
                        <div className="input_label">
                          <p>You Send</p>
                          <p>US Doller</p>
                        </div>

                        <div className="input_wrap">
                          <Input
                            type="email"
                            name="email"
                            id="exampleEmail"
                            placeholder="0.00"
                          />

                          <div className="max-here">
                            <Button
                              className="btn-click"
                              onClick={() => setselectoken(true)}
                            >
                              <img
                                src="/images/yellowbitcoin.png"
                                alt=""
                                className="img-fluid"
                              />
                              <p>Bitcoin</p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <path
                                  d="M21.625 11.625C21.8542 11.8542 21.9688 12.1458 21.9688 12.5C21.9688 12.8542 21.8542 13.1458 21.625 13.375L15.875 19.125C15.75 19.25 15.6146 19.3387 15.4688 19.3912C15.3229 19.4429 15.1667 19.4687 15 19.4687C14.8333 19.4687 14.6717 19.4375 14.515 19.375C14.3592 19.3125 14.2292 19.2292 14.125 19.125L8.375 13.375C8.14584 13.1458 8.03125 12.8542 8.03125 12.5C8.03125 12.1458 8.14584 11.8542 8.375 11.625C8.60417 11.3958 8.89583 11.2812 9.25 11.2812C9.60417 11.2812 9.89584 11.3958 10.125 11.625L15 16.5L19.875 11.625C20.1042 11.3958 20.3958 11.2812 20.75 11.2812C21.1042 11.2812 21.3958 11.3958 21.625 11.625Z"
                                  fill="#000"
                                />
                              </svg>
                            </Button>
                          </div>
                        </div>
                      </FormGroup>

                      <div className="centercontent text-start py-3">
                        <p>
                          1 BTC ~ 33,833.39 <span>USD</span>
                        </p>
                      </div>

                      <FormGroup className="input_here_wrap">
                        <div className="input_label">
                          <p>You get</p>
                          <p>Bitcoin</p>
                        </div>

                        <div className="input_wrap">
                          <Input
                            type="email"
                            name="email"
                            id="exampleEmail"
                            placeholder="0.00"
                          />

                          <div className="max-here">
                            <Button
                              className="btn-click"
                              onClick={() => setselectoken(true)}
                            >
                              <img
                                src="/images/question.png"
                                alt=""
                                className="img-fluid"
                              />
                              <p>MU</p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <path
                                  d="M21.625 11.625C21.8542 11.8542 21.9688 12.1458 21.9688 12.5C21.9688 12.8542 21.8542 13.1458 21.625 13.375L15.875 19.125C15.75 19.25 15.6146 19.3387 15.4688 19.3912C15.3229 19.4429 15.1667 19.4687 15 19.4687C14.8333 19.4687 14.6717 19.4375 14.515 19.375C14.3592 19.3125 14.2292 19.2292 14.125 19.125L8.375 13.375C8.14584 13.1458 8.03125 12.8542 8.03125 12.5C8.03125 12.1458 8.14584 11.8542 8.375 11.625C8.60417 11.3958 8.89583 11.2812 9.25 11.2812C9.60417 11.2812 9.89584 11.3958 10.125 11.625L15 16.5L19.875 11.625C20.1042 11.3958 20.3958 11.2812 20.75 11.2812C21.1042 11.2812 21.3958 11.3958 21.625 11.625Z"
                                  fill="#000"
                                />
                              </svg>
                            </Button>
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="payment_method_select d-flex gap-2 align-items-center">
                      <p className="m-0">Payment method:</p>
                      <div className="method-drop">
                        <UncontrolledDropdown>
                          <DropdownToggle>
                            Visa / Mastercard
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M8 10L12 14L16 10"
                                  stroke="#202020"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem>Another Action</DropdownItem>
                            <DropdownItem>Another Action</DropdownItem>
                            <DropdownItem>Another Action</DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>

                    {/* <Button className="btn_sign_in w-100 mt-4 btn_theme">
                      Buy BTC now
                    </Button> */}
                  </div>

                  <Col lg={6} className="my-4">
                    <div className="transack d-flex justify-content-between align-items-center py-3">
                      <div className="transsac_with_icon d-flex justify-content-between align-items-center">
                        <div className="trasack_icon me-2">
                          <img
                            src="/images/blueeth.png"
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                        <p className="m-0">Transak</p>
                      </div>
                      <div className="transaction_value">
                        <h4>0.00434 BTC</h4>
                      </div>
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="wallet_Address">
                      <h3>Wallet address</h3>

                      <FormGroup>
                        <Input
                          type="email"
                          name="email"
                          id="exampleEmail"
                          placeholder="Enter your ETH Address"
                        />
                      </FormGroup>

                      <FormGroup check>
                        <Label check>
                          <Input type="checkbox" /> I agree with{" "}
                          <a href="javascript:void(0)">Terms of Use</a>,{" "}
                          <a href="javascript:void(0)">Privacy Policy</a> and{" "}
                          <a href="javascript:void(0)">AML/KYC</a>
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="wallet_Address mt-4">
                      <Button
                        className="btn_sign_in w-100 btn_theme"
                        onClick={() => setbuycryptomodone(true)}
                      >
                        Buy 0.556898 BTC
                      </Button>
                    </div>
                  </Col>
                </Form>
              </div>
            </Col>
            <Col lg={4} md={6} sm={12} className="order-3 order-lg-3">
              <div className="Buystepone_stepper">
                <Steper />
              </div>
            </Col>
          </Row>
        </Container>
        <div className="bottom_circle"></div>
      </section>
    </Fade>
  );
};

export default Buydetails;
